import { MESSAGES_SUCCESS, MESSAGES_ERROR, MESSAGES_LOADING, MESSAGES_REMOVE_ALERT } from 'helpers/types';
import * as MessageTypes from 'helpers/messageTypes';

const INITIAL_STATE = {
  bannerMessages: [],
  alertMessages: [],
  error: false,
  loading: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case MESSAGES_SUCCESS:
      const currentDate = new Date();
      const bannerMessages = action.payload
        .filter(
          (banner) =>
            banner.type === MessageTypes.banner_message &&
            currentDate > new Date(banner.start) &&
            currentDate < new Date(banner.end)
        )
        .map((msg) => msg.text);
      const alertMessages = action.payload
        .filter(
          (alert) =>
            alert.type === MessageTypes.alert_message &&
            currentDate > new Date(alert.start) &&
            currentDate < new Date(alert.end)
        )
        .map((msg) => msg.text);
      return {
        bannerMessages,
        alertMessages,
        error: false,
        loading: false,
      };
    case MESSAGES_REMOVE_ALERT:
      return {
        ...state,
        alertMessages: [...state.alertMessages.filter((item) => item !== action.payload)],
      };
    case MESSAGES_ERROR:
      return {
        alertMessages: [],
        bannerMessages: [],
        error: action.payload,
        loading: false,
      };
    case MESSAGES_LOADING:
      return {
        alertMessages: [],
        bannerMessages: [],
        error: false,
        loading: true,
      };
    default:
      return state;
  }
}
